import { useEffect, useState } from 'react';
import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';

interface RemoveMatrixItemModalProps {
    item: { id: string; name: string } | null;
    isRemoving: boolean;
    onDismiss: () => void;
    onConfirmRemove: () => void;
}

export const RemoveMatrixItemModal = ({
    item,
    isRemoving,
    onDismiss,
    onConfirmRemove,
}: RemoveMatrixItemModalProps) => {
    const visible = Boolean(item?.id);
    const [confirmReady, setConfirmReady] = useState(false);

    useEffect(() => {
        if (!visible) {
            setConfirmReady(false);
            return;
        }
        setConfirmReady(false);
        const timer = window.setTimeout(() => setConfirmReady(true), 400);
        return () => window.clearTimeout(timer);
    }, [visible, item?.id]);

    const itemName = item?.name?.trim() || 'this item';

    return (
        <CustomModal
            onDismiss={onDismiss}
            visible={visible}
            header="Remove from matrix?"
            footer={
                <div className="modal-footer-actions">
                    <Btn
                        variant="secondary-outlined"
                        buttonText="Cancel"
                        buttonDisabled={isRemoving}
                        buttonOnClick={onDismiss}
                    />
                    <Btn
                        variant="danger"
                        buttonText={isRemoving ? 'Removing...' : 'Remove'}
                        buttonDisabled={isRemoving || !confirmReady}
                        buttonOnClick={onConfirmRemove}
                    />
                </div>
            }
        >
            <p>
                You are about to unlink <strong>“{itemName}”</strong> from this equipment’s PM matrix.
            </p>
            <p>The item stays in Resources. Only this configuration loses the row.</p>
        </CustomModal>
    );
};
